import React, { useRef, useState } from "react";

interface IFileUploaderProps {
  onChange: (file: File) => void;
  isUploading?: boolean;
}

export const FileUploader = (props: IFileUploaderProps) => {
  const [file, setFile] = useState<File | null>(null);

  const fileInputRef = useRef<HTMLInputElement>(null);

  const handleFileChange = async (
    event: React.ChangeEvent<HTMLInputElement>
  ) => {
    const selectedFile = event.target.files?.[0] || null;
    setFile(selectedFile);
  };

  const handleReset = () => {
    setFile(null);
    if (fileInputRef.current) {
      fileInputRef.current.value = "";
    }
  };

  const handleImport = () => {
    if (!file) {
      alert("Please select a file before importing.");
      return;
    }
    console.log("Importing file:", file.name);
    props.onChange(file);

    handleReset();
  };

  return (
    <div className="p-2 shadow-md max-w-md mx-auto">
      <label className="block font-medium mb-2">Upload File</label>
      <input
        type="file"
        accept=".zip, .dxf, .kml, .kmz"
        onChange={handleFileChange}
        ref={fileInputRef}
        className="w-full p-2 border rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500"
      />
      {file && (
        <p className="text-sm text-gray-600 mt-2">Selected: {file.name}</p>
      )}

      <div className="flex justify-end space-x-2 mt-4">
        <button onClick={handleReset} className="px-4 py-2 hover:bg-gray-100">
          Reset
        </button>

        <button
          onClick={handleImport}
          className="px-4 py-2 border rounded-lg bg-[#2fe9ff] text-white hover:bg-[#2fe9ff]-600 flex items-center justify-center"
          disabled={props.isUploading}
        >
          {props.isUploading ? (
            <div className="animate-spin rounded-full h-5 w-5 border-t-2 border-b-2 border-white mr-2"></div>
          ) : null}
          {props.isUploading ? "Uploading..." : "Import"}
        </button>
      </div>
    </div>
  );
};
